import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "py-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", {
  class: "anchor fw-bolder mb-5",
  id: "Colors"
}, [
  /*#__PURE__*/_createElementVNode("a", { href: "#colors" }),
  /*#__PURE__*/_createTextVNode(" Colors ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "py-5" }, [
  /*#__PURE__*/_createTextVNode(" Use "),
  /*#__PURE__*/_createElementVNode("code", null, ".bg-{color}"),
  /*#__PURE__*/_createTextVNode(" class to set a bullets background color: ")
], -1)
const _hoisted_4 = { class: "py-5" }
const _hoisted_5 = { class: "rounded border p-10" }
const _hoisted_6 = { class: "d-flex flex-column" }
const _hoisted_7 = { class: "py-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.colors, (item, i) => {
            return (_openBlock(), _createElementBlock("li", {
              key: i,
              class: "d-flex align-items-center py-2"
            }, [
              _createElementVNode("span", {
                class: _normalizeClass([`bg-${item}`, "bullet me-5"])
              }, null, 2),
              _createTextVNode(_toDisplayString(item), 1)
            ]))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_CodeHighlighter, {
        fieldHeight: 400,
        lang: "html"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(`
        <div class="d-flex flex-column">
          <li class="d-flex align-items-center py-2">
            <span class="bullet bg-white"></span> white
          </li>
          <li class="d-flex align-items-center py-2">
            <span class="bullet bg-primary"></span> primary
          </li>
          <li class="d-flex align-items-center py-2">
            <span class="bullet bg-light"></span> light
          </li>
          <li class="d-flex align-items-center py-2">
            <span class="bullet bg-secondary"></span> secondary
          </li>
          <li class="d-flex align-items-center py-2">
            <span class="bullet bg-success"></span> success
          </li>
          <li class="d-flex align-items-center py-2">
            <span class="bullet bg-info"></span> info
          </li>
          <li class="d-flex align-items-center py-2">
            <span class="bullet bg-warning"></span> warning
          </li>
          <li class="d-flex align-items-center py-2">
            <span class="bullet bg-danger"></span> danger
          </li>
          <li class="d-flex align-items-center py-2">
            <span class="bullet bg-dark"></span> dark
          </li>
        </div>
        `))
        ]),
        _: 1
      })
    ])
  ]))
}